import { Col, Flex, Form, Input } from 'antd'
import React from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import PhoneInput from 'react-phone-number-input/input'
import { isValidPhoneNumber } from 'react-phone-number-input'

export default function BoxAccessibilityTab ({ form, state }) {
  return (
    <div>
      <Flex justify='space-between'>
        <Col style={{ width: '24%' }}>
          <h3>{t('Admin.BoxForm.phones')}</h3>
          <Flex justify='space-between'>
            <Form.Item name="interphone" label={t('Admin.BoxForm.interphone')}
              rules={[
                {
                  validator: (_, value) =>
                    value === undefined || isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Numéro incorrect'))
                }
              ]}>
              <PhoneInput country='FR' className='ant-input css-dev-only-do-not-override-xfszwz PhoneInput' disabled={state === 'show'} style={{ fontSize: '14px', padding: '4px 11px' }} />
            </Form.Item>
            <Form.Item name="pcc_phone" label={t('Admin.BoxForm.pcc_phone')}
              rules={[
                {
                  validator: (_, value) =>
                    value ? (isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Numéro incorrect'))) : Promise.resolve()
                }
              ]}>
              <PhoneInput country='FR' className='ant-input css-dev-only-do-not-override-xfszwz PhoneInput' disabled={state === 'show'} style={{ fontSize: '14px', padding: '4px 11px' }} />
            </Form.Item>
          </Flex>
        </Col>
        <Col style={{ width: '20%' }}>
          <h3>{t('Admin.BoxForm.digicodes')}</h3>
          <Flex justify='space-between'>
            <Col>
              <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.cleanup_code')}</div>
              <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('cleanup_code')}</div>
            </Col>
            <Col>
              <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.daily_code')}</div>
              <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('daily_code')}</div>
            </Col>
            <Col>
              <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.emergency_code')}</div>
              <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('emergency_code')}</div>
            </Col>
          </Flex>
        </Col>
        <Col style={{ width: '48%' }}>
          <h3>{t('Admin.BoxForm.locks')}</h3>
          <Flex justify='space-between'>
            <Form.Item name="lock_1" label={t('Admin.BoxForm.lock_1')}>
              <Input />
            </Form.Item>
            <Form.Item name="lock_2" label={t('Admin.BoxForm.lock_2')}>
              <Input />
            </Form.Item>
            <Form.Item name="lock_3" label={t('Admin.BoxForm.lock_3')}>
              <Input />
            </Form.Item>
            <Form.Item name="lock_4" label={t('Admin.BoxForm.lock_4')}>
              <Input />
            </Form.Item>
          </Flex>
        </Col>
      </Flex>
      <Form.Item name="comment" label={t('Admin.BoxForm.comment')} style={{ width: '100%' }}>
        <TextArea rows={10} />
      </Form.Item>
    </div>
  )
}
